import React, { useEffect, useState } from "react";
import Header from "../layout/Header";
import { connect, useDispatch } from "react-redux";
import jsPDF from "jspdf";
import { useNavigate, useParams } from "react-router";
import Swal from "sweetalert2";
import robotoLight from "../../helpers/fonts/robotoLight";
import robotoBold from "../../helpers/fonts/robotoBold";
import logo from "../../helpers/onedose_black.png";
import { getOtp } from "../../actions/agreement/getOtp";
import { approveOtp } from "../../actions/agreement/approveOtp";
import { professionsv2 } from "../../actions/v3/professions";
import { careProvidersv2 } from "../../actions/v3/careProviders";
import { startApplicationv2 } from "../../actions/v3/startApplication";
import { Modal, Button, Input, Select, Checkbox } from "antd"; // Ant Design Modal, Button, Input, Select İçe Aktarıldı
import PdfViewerModal from "./components/PdfViewerModal";

const { Option } = Select;

// Sabit kullanılacak alanlar
const DEFAULT_PROFESSION = {
  code: "149", // uzmanlık alanı kodu
  name: "Acil (Çocuk)", // örnek
};
const DEFAULT_CARE_PROVIDER = {
  careProviderId: "DK2249",
  fullName: "Özlem TEKŞAM",
  title: "Prof.Dr.",
  // diğer field'lar gerekiyorsa ekle
};
const DEFAULT_FACILITY_ID = 0; // veya sizin kurum id

function NewApplication(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { FacilityId } = useParams();
  const [mounted, setMounted] = useState(false);
  const [veriCode, setVeriCode] = useState("");
  const [displayCard, setDisplayCard] = useState("triageform");
  const [professionId, setProfessionId] = useState(DEFAULT_PROFESSION.code);
  const [careProviderId, setCareProviderId] = useState(
    DEFAULT_CARE_PROVIDER.careProviderId
  );
  const [careProviderData, setCareProviderData] = useState(
    DEFAULT_CARE_PROVIDER
  );

  const [relativeName, setRelativeName] = useState("");
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [show5, setShow5] = useState(false);

  const [institution, setInstitution] = useState(parseInt(DEFAULT_FACILITY_ID));
  const [doctorCvUrl, setDoctorCvUrl] = useState(false);
  const [forSomeoneElse, setForSomeoneElse] = useState(false);
  const [approveRelative, setApproveRelative] = useState(false);
  const [representedPatientInformation, setRepresentedPatientInformation] =
    useState(null);
  const [base64Pdf, setBase64Pdf] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  // Modal Görünürlüğünü Kontrol Eden State Değişkenleri
  const [isModal128Visible, setIsModal128Visible] = useState(false);
  const [isModal129Visible, setIsModal129Visible] = useState(false);
  const [isModal130Visible, setIsModal130Visible] = useState(false);
  const [isVerificationCodeModalVisible, setIsVerificationCodeModalVisible] =
    useState(false);
  const [isCvModalVisible, setIsCvModalVisible] = useState(false);
  // Her bir textarea için satır sayısını tutan bir nesne
  const [rows, setRows] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [timeSizeLeft, setTimeSizeLeft] = useState(5);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    if (parseInt(FacilityId) === 1) {
      setIsModalVisible(true);
    }
  }, [FacilityId]);

  // Belirli bir textarea'nın satır sayısını ayarlayan fonksiyon
  const setRowForTextarea = (id, rowCount) => {
    setRows((prevRows) => ({
      ...prevRows,
      [id]: rowCount,
    }));
  };

  /** Sms zamanlayıcısı başlangıç */
  const [timeLeft, setTimeLeft] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  useEffect(() => {
    // Eğer süre kalmadıysa ve sayaç hala çalışıyor durumda ise, sayaç durdurulur
    if (timeLeft === 0 && isRunning) {
      setIsRunning(false);
    }
    // Sayaç çalışıyorsa ve hala süre varsa
    if (isRunning && timeLeft > 0) {
      const interval = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);

      // Cleanup fonksiyonu
      return () => clearInterval(interval);
    }
  }, [isRunning, timeLeft]);

  const startTimer = () => {
    setIsRunning(true);
    setTimeLeft(180);
  };
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  /** Sms zamanlayıcısı bitiş */

  const [cures, setCure] = useState([
    {
      r1: "",
      r2: "",
      r3: "",
      r4: "",
    },
  ]);
  const [medicines, setMedicine] = useState([
    {
      r1: "",
      r2: "",
    },
  ]);
  const [addictions, setAddiction] = useState([
    {
      r1: "",
      r2: "",
    },
  ]);
  const [operations, setOperation] = useState([{}]);
  const [pdfFile, setPdfFile] = useState("");
  const [allergies, setAllergy] = useState(false);
  const [relativeDisease, setRelativeDisease] = useState(false);
  const [approve, setApprove] = useState(false);
  const [approve2, setApprove2] = useState(false);
  const [approvePatient, setApprovePatient] = useState(false);
  const [pdfPreviewVisible, setPdfPreviewVisible] = useState(false); // Modal görünürlüğü için state
  const [pdfBlobUrl, setPdfBlobUrl] = useState("");

  useEffect(() => {
    if (isModalVisible && timeSizeLeft > 0) {
      const timer = setInterval(() => {
        setTimeSizeLeft((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (timeSizeLeft === 0) {
      setIsButtonDisabled(false);
    }
  }, [isModalVisible, timeSizeLeft]);

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const [form, setForm] = useState({
    "Görüş Almak İstediğiniz Uzmanlık Alanı": DEFAULT_PROFESSION.name,
    "Görüş Almak İstediğiniz Hastalık": "",
    "Görüş Almak İstediğiniz Konu": {
      "Yakın zamanda konulan bir teşhis hakkında görüş almak istiyorum": "",
      "Planlanan bir ameliyat hakkında görüş almak istiyorum": "",
      "Yaşadığım, bir türlü sağlıklı bir çözüme ulaşmayan kronik bir tıbbi sorunumla ilgili görüş almak istiyorum":
        "",
      "Halihazırda uygulanmakta olan/Önerilen tedavi planım hakkında görüş almak istiyorum":
        "",
      "Hastalığımla ilişkili cevaplanmasını istediğim spesifik sorularım var":
        "",
    },
    "Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi": "",
    "Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri": "",
    "Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar": "",
    "Geçirilmiş Operasyonlar": {},
    "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {},
    "Görüş alınmak istenen hastalık dışında varsa diğer hastalıklar": "",
    "Kullanımı devam eden ilaçlar": {},
    Alışkanlıklar: {},
    "Alerji durumunuz": "",
    "Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?": "",
  });

  useEffect(() => {
    const loadProfessions = async () => {
      try {
        await dispatch(professionsv2(institution));
      } catch (error) {
        console.error("Professions yüklenirken bir hata oluştu:", error);
      }
    };

    loadProfessions();
  }, [dispatch, institution]);

  useEffect(() => {
    localStorage.setItem("whichOne", "");
  }, []);

  const handleExportToPDF = () => {
    return new Promise((resolve, reject) => {
      try {
        const doc = new jsPDF({
          orientation: "p",
          unit: "pt",
          format: "a4",
        });

        doc.addFileToVFS("Roboto-Regular.ttf", robotoLight);
        doc.addFileToVFS("Roboto-Bold.ttf", robotoBold);
        doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
        doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");

        const maxWidth = 500;
        const lineSpacing = 20;
        const initialContentStartY = 230;
        let contentStartY = initialContentStartY;

        const addHeader = () => {
          doc.addImage(logo, "PNG", 40, 16, 50, 32, "", "FAST");

          doc.setFontSize(14);
          doc.setFont("Roboto", "bold");
          doc.text(
            "İKİNCİ GÖRÜŞ BAŞVURU BELGESİ",
            doc.internal.pageSize.getWidth() / 2,
            40,
            { align: "center" }
          );

          doc.setFontSize(10);
          doc.setFont("Roboto", "normal");
          doc.text(
            `${new Date().toLocaleDateString()}`,
            doc.internal.pageSize.getWidth() - 100,
            67
          );

          const boxX = 40;
          const boxY = 70;
          const boxWidth = 510;
          const boxHeight = 130;

          doc.setFontSize(12);
          doc.setFont("Roboto", "normal");
          doc.rect(boxX, boxY, boxWidth, boxHeight);

          let infoContentY = boxY + 20;
          const infoContentX = boxX + 10;
          const lineHeight = 30;

          // Başvuran Adı Soyadı - Yakını İçin Kontrol
          // Başvuran Adı Soyadı ve Hasta Adı Soyadı
          const applicantName = `${user?.name || "Bilinmiyor"} ${
            user?.lastName || ""
          }`;
          const patientName = forSomeoneElse
            ? representedPatientInformation?.name +
                " " +
                representedPatientInformation?.surname || "Bilinmiyor"
            : applicantName; // Eğer başka biri için başvuru yoksa, başvuran adı olu

          // Hasta Adı Soyadı (Eğer Başka Biri İçin ise)
          doc.setFont("Roboto", "bold");
          doc.text(`Hasta Adı Soyadı:`, infoContentX, infoContentY);
          doc.setFont("Roboto", "normal");
          doc.text(
            forSomeoneElse ? patientName : applicantName,
            infoContentX + 130,
            infoContentY
          ); // Bir sonraki satıra geç

          infoContentY += lineHeight;
          doc.setFont("Roboto", "bold");
          doc.text(`Uzmanlık Alanı:`, infoContentX, infoContentY);
          doc.setFont("Roboto", "normal");
          doc.text(
            `${form["Görüş Almak İstediğiniz Uzmanlık Alanı"]}`,
            infoContentX + 130,
            infoContentY
          );

          infoContentY += lineHeight;
          doc.setFont("Roboto", "bold");
          doc.text(`Başvuralan Hekim:`, infoContentX, infoContentY);
          doc.setFont("Roboto", "normal");
          doc.text(
            `${careProviderData?.fullName || "Bilinmiyor"}`,
            infoContentX + 130,
            infoContentY
          );

          infoContentY += lineHeight;
          doc.setFont("Roboto", "bold");
          doc.text(`Başvuru Tarihi:`, infoContentX, infoContentY);
          doc.setFont("Roboto", "normal");
          doc.text(
            `${new Date().toLocaleDateString()}`,
            infoContentX + 130,
            infoContentY
          );

          contentStartY = initialContentStartY;
        };
        const footerImage = "/assets/images/esigned.png";

        const addFooterImage = () => {
          const pageWidth = doc.internal.pageSize.getWidth();
          const pageHeight = doc.internal.pageSize.getHeight();
          const imageWidth = 30; // Görselin genişliği
          const imageHeight = 30; // Görselin yüksekliği
          const imageX = pageWidth - imageWidth - 20; // Sağ kenardan 20 birim boşluk
          const imageY = pageHeight - imageHeight - 20; // Alt kenardan 20 birim boşluk

          doc.addImage(
            footerImage,
            "PNG",
            imageX,
            imageY,
            imageWidth,
            imageHeight
          );
        };

        addFooterImage();

        const addContent = (content) => {
          const pageHeight = doc.internal.pageSize.getHeight();

          if (Array.isArray(content)) {
            content.forEach((item) => {
              const lines = doc.splitTextToSize(item, maxWidth);
              lines.forEach((line) => {
                if (contentStartY + lineSpacing > pageHeight) {
                  doc.addPage();
                  addHeader();
                  contentStartY = initialContentStartY;
                }
                doc.text(line, 40, contentStartY);
                contentStartY += lineSpacing;
              });
            });
          } else if (typeof content === "object") {
            for (const subProperty in content) {
              const subValue = content[subProperty];
              if (!subValue) continue; // Boş değerleri atla
              doc.setFont("Roboto", "bold");
              doc.text(`${subProperty}:`, 40, contentStartY);
              contentStartY += lineSpacing;
              doc.setFont("Roboto", "normal");
              const lines = doc.splitTextToSize(subValue, maxWidth);
              lines.forEach((line) => {
                if (contentStartY + lineSpacing > pageHeight) {
                  doc.addPage();
                  addHeader();
                  contentStartY = initialContentStartY;
                }
                doc.text(line, 40, contentStartY);
                contentStartY += lineSpacing;
              });
              contentStartY += lineSpacing; // Her alt bölümden sonra ekstra boşluk ekle
            }
          } else {
            const contentLines = doc.splitTextToSize(content, maxWidth);
            contentLines.forEach((line) => {
              if (contentStartY + lineSpacing > pageHeight) {
                doc.addPage();
                addHeader();
                contentStartY = initialContentStartY;
              }
              doc.text(line, 40, contentStartY);
              contentStartY += lineSpacing;
            });
          }
        };

        const addSection = (content, title) => {
          if (
            !content ||
            (typeof content === "object" && Object.keys(content).length === 0)
          ) {
            return; // Boş bölümleri atla
          }

          const pageHeight = doc.internal.pageSize.getHeight();

          if (contentStartY + 30 > pageHeight) {
            doc.addPage();
            addHeader();
            contentStartY = initialContentStartY;
          }

          doc.setFontSize(12);
          doc.setFont("Roboto", "bold");
          doc.text(title, 40, contentStartY);
          contentStartY += 20;

          doc.setFont("Roboto", "normal");
          addContent(content);
        };

        addHeader();
        if (form["Görüş Almak İstediğiniz Konu"]) {
          addSection(
            form["Görüş Almak İstediğiniz Konu"],
            "GÖRÜŞ ALMAK İSTEDİĞİNİZ KONU"
          );
        }
        if (
          form[
            "Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri"
          ]
        ) {
          addSection(
            form[
              "Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri"
            ],
            "DAHA ÖNCE BAŞVURULAN HEKİM/SAĞLIK MERKEZLERİ VE BAŞVURU TARİHLERİ"
          );
        }
        if (form["Hastalık İle İlgili Aktarılmak İsteyen Diğer Notlar"]) {
          addSection(
            form["Hastalık İle İlgili Aktarılmak İsteyen Diğer Notlar"],
            "HASTALIK İLE İLGİLİ AKTARILMAK İSTENEN DİĞER NOTLAR"
          );
        }
        if (form["Geçirilmiş Operasyonlar"]) {
          addSection(
            form["Geçirilmiş Operasyonlar"],
            "GEÇİRİLMİŞ OPERASYONLAR"
          );
        }
        if (form["Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"]) {
          addSection(
            form["Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"],
            "HASTALIK İLE İLGİLİ GÜNÜMÜZE DEK ALINAN TEDAVİLER"
          );
        }
        if (
          form["Görüş alınmak istenen hastalık dışında varsa diğer hastalıklar"]
        ) {
          addSection(
            form[
              "Görüş alınmak istenen hastalık dışında varsa diğer hastalıklar"
            ],
            "GÖRÜŞ ALINMAK İSTENEN HASTALIK DIŞINDA VARSA DİĞER HASTALIKLAR"
          );
        }
        if (form["Kullanımı devam eden ilaçlar"]) {
          addSection(
            form["Kullanımı devam eden ilaçlar"],
            "KULLANIMI DEVAM EDEN İLAÇLAR"
          );
        }
        if (form["Alışkanlıklar"]) {
          addSection(form["Alışkanlıklar"], "ALIŞKANLIKLAR");
        }
        if (form["Alerji durumunuz"]) {
          addSection(form["Alerji durumunuz"], "ALERJİ DURUMUNUZ");
        }
        if (
          form["Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?"]
        ) {
          addSection(
            form["Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?"],
            "GÖRÜŞ ALMAK İSTEDİĞİNİZ HASTALIĞI AİLENİZDE YAŞAYAN VAR MI?"
          );
        }

        const pdfAsBase64 = doc.output("datauristring");
        setPdfFile(pdfAsBase64);
        setBase64Pdf(pdfAsBase64); // Modal PDF durumunu güncelle

        resolve(pdfAsBase64); // PD
        addHeader();

        resolve(doc.output("datauristring"));
        const blob = doc.output("blob");
        const url = URL.createObjectURL(blob);
        setPdfBlobUrl(url); // Blob URL'yi state'de sakla
        setPdfPreviewVisible(true); // Modal'ı göster
      } catch (error) {
        reject(error);
      }
    });
  };

  useEffect(() => {
    if (props.approveOtp.done) {
      setVeriCode("");
      setIsVerificationCodeModalVisible(false); // Doğrulama modalını kapat
      handleSubmit();
    }
  }, [props.approveOtp]);

  const handleSubmit = async (event) => {
    // "Yakınım için yapıyorum" seçeneğine göre alanları kontrol et
    if (forSomeoneElse) {
      const {
        name,
        surname,
        nationalIdentifier,
        birthDateDay,
        birtDateMonth,
        birthDateYear,
        gender,
      } = representedPatientInformation || null;

      // Kullanıcı ve yakının T.C. numarası aynı mı kontrolü
      if (user?.nationalId === nationalIdentifier) {
        Swal.fire({
          icon: "error",
          title: "Kayıt olan kişi ile yakın bilgisi aynı olamaz.",
          text: "Kendi adınıza başvuru yapıyorsanız lütfen yakın bilgileri kısmını doldurmayınız!",
          confirmButtonText: "Anladım",
        });
        setForSomeoneElse(false);
        setRepresentedPatientInformation(null);
        return; // Başvuru işlemini durdur
      }

      // Eksik alanlar için kullanıcıyı bilgilendir
      if (
        !name ||
        !surname ||
        !nationalIdentifier ||
        !birthDateDay ||
        !birtDateMonth ||
        !birthDateYear ||
        !gender
      ) {
        Swal.fire({
          icon: "error",
          title: "Zorunlu alanlar doldurulmalı",
          text: "Yakınınıza ait tüm bilgileri doldurunuz.",
          confirmButtonText: "Anladım",
        });
        return;
      }
    } else {
      // Yakınım için seçilmediyse bilgileri sıfırla
      setRepresentedPatientInformation(null);
    }

    // Formun diğer alanlarını kontrol et
    if (
      !form["Görüş Almak İstediğiniz Uzmanlık Alanı"] ||
      !form["Görüş Almak İstediğiniz Hastalık"]
    ) {
      Swal.fire({
        icon: "error",
        title: "Zorunlu alanlar doldurulmalı",
        text: "Lütfen tüm zorunlu alanları doldurun.",
        confirmButtonText: "Anladım",
      });
      return;
    }

    // PDF oluştur ve formu gönder
    try {
      const pdfBase64 = await handleExportToPDF();

      const surveyData = {
        surveyName: "İkinci Görüş Talep Formu",
        data: JSON.stringify({
          ...form,
        }),
        pdfData: pdfBase64,
      };

      dispatch(
        startApplicationv2(
          careProviderData,
          surveyData,
          institution,
          representedPatientInformation
        )
      );
      setMounted(true);
    } catch (error) {
      console.error("PDF oluşturma işleminde bir hata oluştu:", error);
    }
  };

  function handleVerify() {
    if (form["Görüş Almak İstediğiniz Uzmanlık Alanı"] === "") {
      Swal.fire({
        icon: "error",
        title: "Zorunlu alanlar doldurulmalı",
        text: "Lütfen zorunlu alanları doldurunuz.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
      return;
    }
    if (form["Görüş Almak İstediğiniz Hastalık"] === "") {
      Swal.fire({
        icon: "error",
        title: "Zorunlu alanlar doldurrulmalı",
        text: "Lütfen zorunlu alanları doldurunuz.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
      return;
    }

    setIsVerificationCodeModalVisible(true); // Doğrulama kodu modalını aç
    dispatch(getOtp());
  }

  function handleCreateApplication() {
    if (form["Görüş Almak İstediğiniz Uzmanlık Alanı"] === "") {
      Swal.fire({
        icon: "error",
        title: "Zorunlu alanlar doldurulmalı",
        text: "Lütfen zorunlu alanları doldurunuz.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
      return;
    }
    if (form["Görüş Almak İstediğiniz Hastalık"] === "") {
      Swal.fire({
        icon: "error",
        title: "Zorunlu alanlar doldurrulmalı",
        text: "Lütfen zorunlu alanları doldurunuz.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
      return;
    }

    if (!show && !show2 && !show3 && !show4 && !show5) {
      Swal.fire({
        icon: "error",
        title: "Zorunlu alanlar doldurulmalı",
        text: "En az bir görüş almak istediğiniz konuyu seçmelisiniz.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
      return;
    }
    handleSubmit();
  }

  useEffect(() => {
    if (props.startApplicationv2.done) {
      navigate(
        "/file-uploadv2/" +
          props.startApplicationv2?.startApplicationv2?.result +
          "?facility=" +
          FacilityId
      );
    }
  }, [props.startApplicationv2, navigate, FacilityId]);

  useEffect(() => {
    if (props.careProvidersv2.done) {
      setCareProviderData(props.careProvidersv2?.careProvidersv2?.result?.data);
    }
  }, [props.careProvidersv2]);

  useEffect(() => {
    if (props.getOtp.done) {
      setTimeLeft(180);
      startTimer();
    }
  }, [props.getOtp]);

  useEffect(() => {
    if (props.startApplicationv2.error != false) {
      var errorMessage =
        props.startApplicationv2.error?.response?.data?.responseMessage;

      Swal.fire({
        icon: "error",
        title: "Başvuru oluşturulamadı",
        text: errorMessage,
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
    }
  }, [props.startApplicationv2]);

  return (
    <div>
      <Header />
      <div className="md:justify-center me-4">
        <div className="mb-10" id="triageformcard">
          <div className="pt-10 md:ml-64 ps-5">
            <ol
              className="flex items-center whitespace-nowrap min-w-0"
              aria-label="Breadcrumb"
            >
              <li className="text-sm">
                <span className="flex items-center text-gray-500 ">
                  Yeni Başvuru
                  <svg
                    className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
              </li>
              <span className="flex items-center text-gray-500 ">
                <li
                  className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200"
                  aria-current="page"
                >
                  Talep Formu
                </li>
              </span>
            </ol>
          </div>
          <hr className="divide-y mt-2" />
          <h1 className="md:ml-64 ps-5 mt-5 text-3xl text-start font-semibold">
            İkinci Görüş Talep Formu
          </h1>
          {/* <div className="md:ml-64 dark:bg-dark ps-5 mt-5">
            <div className="text-start">
              <label
                htmlFor="hs-select-label"
                className="block text-sm font-medium mb-2 dark:text-white"
              >
                Görüş Almak İstediğiniz Uzmanlık Alanı
                <b className="text-red-500 hs-tooltip-toggle hs-tooltip inline-block ms-2">
                  *
                  <span
                    className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                    role="tooltip"
                  >
                    Bu alanları doldurmak zorunludur
                  </span>
                </b>
              </label>
              <select
                onChange={(e) => {
                  const selectedOptionText =
                    e.target.options[e.target.selectedIndex].text;

                  setForm((prevState) => ({
                    ...prevState,
                    "Görüş Almak İstediğiniz Uzmanlık Alanı":
                      selectedOptionText,
                  }));
                  setProfessionId(e.target.value);
                  dispatch(careProvidersv2(e.target.value, institution));
                }}
                required
                id="hs-select-label"
                className="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              >
                <option selected>Lütfen Seçiniz</option>
                {props.professionsv2.done ? (
                  props.professionsv2?.professionsv2?.result?.data
                    .sort((a, b) =>
                      a.professionName.localeCompare(b.professionName)
                    ) // Alfabetik sıralama
                    .map((element, index) => (
                      <option value={element.code} key={index}>
                        {element.professionName}
                      </option>
                    ))
                ) : (
                  <option defaultValue="">Alanlar yüklenemedi</option>
                )}
              </select>
            </div>
          </div>
          <div className="md:ml-64 dark:bg-dark ps-5 mt-5">
            <div className="text-start relative">
              <label
                htmlFor="hs-select-label"
                className="block text-sm font-medium mb-2 dark:text-white"
              >
                Görüş Almak İstediğiniz Hekim
                <b className="text-red-500 hs-tooltip-toggle hs-tooltip inline-block ms-2">
                  *
                  <span
                    className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                    role="tooltip"
                  >
                    Bu alanları doldurmak zorunludur
                  </span>
                </b>
              </label>
              <select
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selectedCareProvider =
                    props.careProvidersv2?.careProvidersv2?.result?.data.find(
                      (element) => element.careProviderId === selectedId
                    );
                  setCareProviderData(selectedCareProvider);
                  setDoctorCvUrl(selectedCareProvider.careProviderId);
                }}
                required
                id="hs-select-label"
                className="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              >
                <option selected>Lütfen Seçiniz</option>
                {props.careProvidersv2.done ? (
                  props.careProvidersv2?.careProvidersv2?.result?.data
                    ?.length === 0 ? (
                    <option selected defaultValue="">
                      Seçtiğiniz bölüme ait bir doktor bulunmamaktadır
                    </option>
                  ) : (
                    props.careProvidersv2?.careProvidersv2?.result?.data
                      .sort((a, b) => a.fullName.localeCompare(b.fullName))
                      .map((element, index) => (
                        <option value={element.careProviderId} key={index}>
                          {element.title} {element.fullName}
                        </option>
                      ))
                  )
                ) : (
                  <option selected defaultValue="">
                    Lütfen uzmanlık alanını seçiniz
                  </option>
                )}
              </select>
            </div>
          </div> */}
          <div className="md:ml-64 ps-5 mt-5">
            <label
              htmlFor="input-label"
              className="text-start block text-sm font-medium mb-2 dark:text-white"
            >
              Görüş Almak İstediğiniz Hastalık
              <b className="text-red-500 hs-tooltip-toggle hs-tooltip inline-block ms-2">
                *
                <span
                  className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                  role="tooltip"
                >
                  Bu alanları doldurmak zorunludur
                </span>
              </b>
            </label>
            <input
              onChange={(e) => {
                setForm((prevState) => ({
                  ...prevState,
                  "Görüş Almak İstediğiniz Hastalık": e.target.value,
                }));
              }}
              required
              type="text"
              id="input-label"
              className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              placeholder="Görüş almak istediğiniz hastalığınızı giriniz"
            />
          </div>
          <div className="md:ml-64 ps-5 mt-5">
            <label
              htmlFor="input-label"
              className="text-start block text-sm font-medium mb-2 dark:text-white"
            >
              Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi
              <b className="text-red-500 hs-tooltip-toggle hs-tooltip inline-block ms-2">
                *
                <span
                  className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                  role="tooltip"
                >
                  Bu alanları doldurmak zorunludur
                </span>
              </b>
            </label>
            <input
              onChange={(e) => {
                setForm((prevState) => ({
                  ...prevState,
                  "Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi":
                    e.target.value,
                }));
              }}
              type="text"
              id="input-label"
              className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              placeholder="Lütfen bir tarih giriniz. (Örn; 2 yıl önce, Ağustos 2022)"
              required
            />
          </div>
          <div className=" mt-5 bg-red-400 ">
            <div className="grid justify-center items-center text-center">
              <h4
                htmlFor="gorus-almak-istiyorum"
                className=" text-start text-sm dark:text-black font-bold"
              >
                Görüş Almak İstiyorum
                <b className="text-gray-100 hs-tooltip-toggle hs-tooltip inline-block ms-2">
                  *
                  <span
                    className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                    role="tooltip"
                  >
                    Bu alanları doldurmak zorunludur
                  </span>
                </b>
              </h4>
              <h6 className="text-gray-100 text-center">
                Görüş almak istediğiniz konuları işaretleyiniz ve hakkında detay
                giriniz...
              </h6>
            </div>
          </div>
          <div className="md:ml-60 ps-5 mt-5">
            {/* Yakın zamanda konulan teşhis hakkında */}
            <div className="flex ml-5">
              <input
                type="checkbox"
                className="shrink-0 mt-0.5 me-2 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50"
                id="yakin-konulan-teshis"
                onChange={(e) => setShow(e.target.checked)}
              />
              <label
                htmlFor="yakin-konulan-teshis"
                className="text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Yakın zamanda konulan bir teşhis hakkında
              </label>
            </div>
            {show && (
              <textarea
                disabled={!show}
                onClick={(e) => setRowForTextarea("textarea1", 12)}
                onBlur={(e) => setRowForTextarea("textarea1", 3)}
                onChange={(e) => {
                  setForm((prevState) => ({
                    ...prevState,
                    "Görüş Almak İstediğiniz Konu": {
                      ...prevState["Görüş Almak İstediğiniz Konu"],
                      "Yakın zamanda konulan bir teşhis hakkında görüş almak istiyorum":
                        e.target.value,
                    },
                  }));
                }}
                type="text"
                id=""
                rows={rows["textarea1"] || 3}
                className="py-3 px-4 block disabled:opacity-40 w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="Lütfen detay giriniz"
              />
            )}
          </div>
          <div className="md:ml-60 ps-5 mt-5">
            {/* Planlanan ameliyat hakkında */}
            <div className="flex ml-5">
              <input
                type="checkbox"
                className="shrink-0 mt-0.5 me-2 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50"
                id="planlanan-ameliyat"
                onChange={(e) => setShow2(e.target.checked)}
              />
              <label
                htmlFor="planlanan-ameliyat"
                className="text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Planlanan bir ameliyat hakkında
              </label>
            </div>
            {show2 && (
              <textarea
                disabled={!show2}
                onChange={(e) => {
                  setForm((prevState) => ({
                    ...prevState,
                    "Görüş Almak İstediğiniz Konu": {
                      ...prevState["Görüş Almak İstediğiniz Konu"],
                      "Planlanan bir ameliyat hakkında görüş almak istiyorum":
                        e.target.value,
                    },
                  }));
                }}
                type="text"
                id="planlanan-ameliyat"
                onClick={(e) => setRowForTextarea("textarea2", 12)}
                onBlur={(e) => setRowForTextarea("textarea2", 3)}
                rows={rows["textarea2"] || 3}
                className="py-3 px-4 block disabled:opacity-40 w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="Lütfen detay giriniz"
              />
            )}
          </div>
          <div className="md:ml-60 ps-5 mt-5">
            {/* Kronik problem hakkında */}
            <div className="flex ml-5">
              <input
                type="checkbox"
                className="shrink-0 mt-0.5 me-2 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50"
                id="kronik-problem"
                onChange={(e) => setShow3(e.target.checked)}
              />
              <label
                htmlFor="kronik-problem"
                className="text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Yaşadığım, bir türlü sağlıklı bir çözüme ulaşmayan kronik bir
                tıbbi sorunumla ilgili
              </label>
            </div>
            {show3 && (
              <textarea
                disabled={!show3}
                onChange={(e) => {
                  setForm((prevState) => ({
                    ...prevState,
                    "Görüş Almak İstediğiniz Konu": {
                      ...prevState["Görüş Almak İstediğiniz Konu"],
                      "Yaşadığım, bir türlü sağlıklı bir çözüme ulaşmayan kronik bir tıbbi sorunumla ilgili görüş almak istiyorum":
                        e.target.value,
                    },
                  }));
                }}
                type="text"
                id=""
                onClick={(e) => setRowForTextarea("textarea4", 12)}
                onBlur={(e) => setRowForTextarea("textarea4", 3)}
                rows={rows["textarea4"] || 3}
                className="py-3 px-4 block disabled:opacity-40 w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="Lütfen detay giriniz"
              />
            )}
          </div>
          <div className="md:ml-60 ps-5 mt-5">
            {/* Halihazırda uygulanmakta olan tedavi planı hakkında */}
            <div className="flex ml-5">
              <input
                type="checkbox"
                className="shrink-0 mt-0.5 me-2 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50"
                id="tedavi-planı"
                onChange={(e) => setShow4(e.target.checked)}
              />
              <label
                htmlFor="tedavi-planı"
                className="text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Halihazırda uygulanmakta olan/Önerilen tedavi planım hakkında
              </label>
            </div>
            {show4 && (
              <textarea
                disabled={!show4}
                onChange={(e) => {
                  setForm((prevState) => ({
                    ...prevState,
                    "Görüş Almak İstediğiniz Konu": {
                      ...prevState["Görüş Almak İstediğiniz Konu"],
                      "Halihazırda uygulanmakta olan/Önerilen tedavi planım hakkında görüş almak istiyorum":
                        e.target.value,
                    },
                  }));
                }}
                onClick={(e) => setRowForTextarea("textarea3", 12)}
                onBlur={(e) => setRowForTextarea("textarea3", 3)}
                type="text"
                id=""
                rows={rows["textarea3"] || 3}
                className="py-3 px-4 block disabled:opacity-40 w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="Lütfen detay giriniz"
              />
            )}
          </div>
          <div className="md:ml-60 ps-5 mt-5">
            {/* Spesifik sorular hakkında */}
            <div className="flex ml-5">
              <input
                type="checkbox"
                className="shrink-0 mt-0.5 me-2 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50"
                id="spesifik-sorular"
                onChange={(e) => setShow5(e.target.checked)}
              />
              <label
                htmlFor="spesifik-sorular"
                className="text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Hastalığımla ilişkili cevaplanmasını istediğim spesifik
                sorularım var
              </label>
            </div>
            {show5 && (
              <textarea
                disabled={!show5}
                onChange={(e) => {
                  setForm((prevState) => ({
                    ...prevState,
                    "Görüş Almak İstediğiniz Konu": {
                      ...prevState["Görüş Almak İstediğiniz Konu"],
                      "Hastalığımla ilişkili cevaplanmasını istediğim spesifik sorularım var":
                        e.target.value,
                    },
                  }));
                }}
                type="text"
                onClick={(e) => setRowForTextarea("textarea5", 12)}
                onBlur={(e) => setRowForTextarea("textarea5", 3)}
                rows={rows["textarea5"] || 3}
                className="py-3 px-4 disabled:opacity-40 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="Lütfen detay giriniz"
              />
            )}
          </div>
        </div>

        {/* Diğer Form Alanları */}
        <div className="md:ml-64">
          <div className="h-28 w-full bg-red-400">
            <label
              htmlFor="kafkas5"
              className="text-start block text-sm font-medium mb-2 dark:text-white px-4"
            >
              Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri
            </label>
            <label
              htmlFor="error-next-step"
              className="text-start block text-sm font-medium mb-2 text-gray-100 px-4"
            >
              **Daha önce yapılan test sonuçları(varsa) (kan, radyoloji,
              mikrobiyoloji, patoloji) sonuçlarınızı bir sonraki sayfada
              yükleyiniz.
            </label>
          </div>
          <textarea
            onChange={(e) => {
              setForm((prevState) => ({
                ...prevState,
                "Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri":
                  e.target.value,
              }));
            }}
            onClick={(e) => setRowForTextarea("textarea6", 12)}
            onBlur={(e) => setRowForTextarea("textarea6", 3)}
            rows={rows["textarea6"] || 3}
            type="text"
            id="kafkas5"
            className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
            placeholder="Lütfen görüş almak istediğiniz hastalığınız ile ilgili daha önce başvurduğunuz hekim/sağlık merkezleri ve başvuru tarihlerini belirtiniz."
          />
        </div>
        <div className="md:ml-64 ps-5 mt-5">
          <label
            htmlFor="kafkas6"
            className="text-start block text-sm font-medium mb-2 dark:text-white"
          >
            Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar
          </label>
          <textarea
            onChange={(e) => {
              setForm((prevState) => ({
                ...prevState,
                "Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar":
                  e.target.value,
              }));
            }}
            onClick={(e) => setRowForTextarea("textarea7", 12)}
            onBlur={(e) => setRowForTextarea("textarea7", 3)}
            rows={rows["textarea7"] || 3}
            type="text"
            id="kafkas6"
            className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
            placeholder="Lütfen belirtiniz"
          />
        </div>
        <div className="md:ml-64 ps-5 mt-5">
          <label
            htmlFor="kafkas7"
            className="text-start block text-sm font-medium mb-2 dark:text-white"
          >
            Geçirilmiş Operasyonlar
          </label>

          {operations.map((element, index) => (
            <textarea
              key={index}
              onChange={(e) => {
                setForm((prevState) => ({
                  ...prevState,
                  "Geçirilmiş Operasyonlar": {
                    ...prevState["Geçirilmiş Operasyonlar"],
                    ["Geçirilmiş Operasyon " + index]: e.target.value,
                  },
                }));
              }}
              type="text"
              id="kafkas7"
              className=" mt-2 py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              placeholder="Lütfen görüş almak istediğiniz hastalığınız ile ilgili operasyon adı, tarihi ve operasyonun gerçekleştirildiği sağlık merkezi bilgilerini giriniz"
            />
          ))}
          <div className="flex justify-end">
            <a
              onClick={(e) => {
                e.preventDefault();
                const newOperations = [...operations];
                newOperations.pop();
                setOperation(newOperations);
              }}
              href="#"
              className=" block text-sm font-medium mb-2 danger mt-2 me-2"
            >
              <i className="fa-light fa-minus me-1"></i>
              Daha az
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                setOperation([...operations, { text: "" }]);
              }}
              href="#"
              className=" block text-sm font-medium mb-2 onedose-color mt-2"
            >
              <i className="fa-light fa-plus me-1"></i>
              Daha fazla
            </a>
          </div>
        </div>
        <div className="md:ml-64 ps-5 mt-5">
          <h1 className="text-start mb-2 text-xl font-semibold">
            Hastalık İle İlgili Günümüze Dek Alınan Tedaviler:
          </h1>
          {cures.map((element, index) => (
            <div key={index} className="grid grid-cols-2 gap-2">
              <div>
                <label
                  htmlFor={`question_10_1_${index}`}
                  className="text-start block text-sm font-medium mb-2 dark:text-white"
                >
                  Tedavi Adı
                </label>
                <input
                  onChange={(e) => {
                    setCure(
                      cures.map((c, i) =>
                        i === index ? { ...c, r1: e.target.value } : c
                      )
                    );
                    setForm((prevState) => ({
                      ...prevState,
                      "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {
                        ...prevState[
                          "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                        ],
                        ["Tedavi Adı " + index]: e.target.value,
                      },
                    }));
                  }}
                  name={`question_10_1_${index}`}
                  type="text"
                  id={`q9_${index}`}
                  className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Tedavi/İlaç adını giriniz"
                />
              </div>
              <div>
                <label
                  htmlFor={`question_10_2_${index}`}
                  className="text-start block text-sm font-medium mb-2 dark:text-white"
                >
                  Tedavi Durumu
                </label>
                <select
                  onChange={(e) => {
                    setCure(
                      cures.map((c, i) =>
                        i === index ? { ...c, r2: e.target.value } : c
                      )
                    );
                    setForm((prevState) => ({
                      ...prevState,
                      "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {
                        ...prevState[
                          "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                        ],
                        ["Tedavi Durumu " + index]: e.target.value,
                      },
                    }));
                  }}
                  name={`question_10_2_${index}`}
                  id={`q10_${index}`}
                  className="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                >
                  <option value="" disabled selected>
                    Lütfen seçiniz
                  </option>
                  <option value="Devam Ediyor">Devam ediyor</option>
                  <option value="Sonlandı">Sonlandı</option>
                </select>
              </div>
              <div>
                <label
                  htmlFor={`question_10_3_${index}`}
                  className="text-start block text-sm font-medium mb-2 dark:text-white"
                >
                  Başlangıç Tarihi
                </label>
                <input
                  onChange={(e) => {
                    setCure(
                      cures.map((c, i) =>
                        i === index ? { ...c, r3: e.target.value } : c
                      )
                    );
                    setForm((prevState) => ({
                      ...prevState,
                      "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {
                        ...prevState[
                          "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                        ],
                        ["Tedavi Başlangıç Tarihi " + index]: e.target.value,
                      },
                    }));
                  }}
                  id={`question_10_3_${index}`}
                  name={`q11_${index}`}
                  type="text"
                  className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Örn 2018"
                />
              </div>
              <div>
                {element.r2 === "Sonlandı" ? (
                  <div>
                    <label
                      htmlFor={`question_10_4_${index}`}
                      className="text-start block text-sm font-medium mb-2 dark:text-white"
                    >
                      Bitiş Tarihi
                    </label>
                    <input
                      type="text"
                      onChange={(e) => {
                        setCure(
                          cures.map((c, i) =>
                            i === index ? { ...c, r4: e.target.value } : c
                          )
                        );
                        setForm((prevState) => ({
                          ...prevState,
                          "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {
                            ...prevState[
                              "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                            ],
                            ["Tedavi Bitiş Tarihi " + index]: e.target.value,
                          },
                        }));
                      }}
                      id={`q12_${index}`}
                      name={`question_10_4_${index}`}
                      className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                      placeholder="Örn 2022"
                    />
                  </div>
                ) : null}
              </div>
            </div>
          ))}

          <div className="flex justify-end">
            <a
              onClick={(e) => {
                e.preventDefault();
                const newCures = [...cures];
                newCures.pop();
                setCure(newCures);
              }}
              href="#"
              className=" block text-sm font-medium mb-2 danger mt-2 me-2"
            >
              <i className="fa-light fa-minus me-1"></i>
              Daha az
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                setCure([...cures, { r1: "", r2: "", r3: "", r4: "" }]);
              }}
              href="#"
              className=" block text-sm font-medium mb-2 onedose-color mt-2"
            >
              <i className="fa-light fa-plus me-1"></i>
              Daha fazla
            </a>
          </div>
        </div>
        <div className="md:ml-64 ps-5 mt-5">
          <label
            htmlFor="input-label1"
            className="text-start block text-sm font-medium mb-2 dark:text-white"
          >
            Görüş Alınmak İstediğiniz Hastalık Dışında Varsa Diğer Hastalıklar
            (Özgeçmiş)
          </label>
          <textarea
            onChange={(e) => {
              setForm((prevState) => ({
                ...prevState,
                "Görüş alınmak istenen hastalık dışında varsa diğer hastalıklar":
                  e.target.value,
              }));
            }}
            onClick={(e) => setRowForTextarea("textarea8", 12)}
            onBlur={(e) => setRowForTextarea("textarea8", 3)}
            rows={rows["textarea8"] || 3}
            type="text"
            id="input-label1"
            className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
            placeholder="Bilinen diğer hastalıklar"
          />
        </div>
        <div className="md:ml-64 ps-5 mt-5">
          <h1 className="text-start mb-2 text-xl font-semibold">
            Kullanımı Devam Eden İlaçlar :
          </h1>
          {medicines.map((element, index) => (
            <div key={index} className="grid grid-cols-2 gap-2">
              <div>
                <label
                  htmlFor={`question_20_1_${index}`}
                  className="text-start block text-sm font-medium mb-2 dark:text-white"
                >
                  İlaç Adı ve Dozu
                </label>
                <input
                  onChange={(e) => {
                    setMedicine(
                      medicines.map((c, i) =>
                        i === index ? { ...c, r1: e.target.value } : c
                      )
                    );
                    setForm((prevState) => ({
                      ...prevState,
                      "Kullanımı devam eden ilaçlar": {
                        ...prevState["Kullanımı devam eden ilaçlar"],
                        ["İlaç adı ve dozu " + index]: e.target.value,
                      },
                    }));
                  }}
                  id={`question_20_1_${index}`}
                  type="text"
                  className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="İlaç adı ve dozunu giriniz"
                />
              </div>
              <div>
                <label
                  htmlFor={`question_10_4_${index}`}
                  className="text-start block text-sm font-medium mb-2 dark:text-white"
                >
                  Başlangıç Zamanı
                </label>
                <input
                  onChange={(e) => {
                    setMedicine(
                      medicines.map((c, i) =>
                        i === index ? { ...c, r2: e.target.value } : c
                      )
                    );
                    setForm((prevState) => ({
                      ...prevState,
                      "Kullanımı devam eden ilaçlar": {
                        ...prevState["Kullanımı devam eden ilaçlar"],
                        ["İlaç başlangıç zamanı " + index]: e.target.value,
                      },
                    }));
                  }}
                  id={`question_10_4_${index}`}
                  placeholder="Örn bir haftada önce"
                  className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                />
              </div>
            </div>
          ))}

          <div className="flex justify-end">
            <a
              onClick={(e) => {
                e.preventDefault();
                const newMedicines = [...medicines];
                newMedicines.pop();
                setMedicine(newMedicines);
              }}
              href="#"
              className=" block text-sm font-medium mb-2 danger mt-2 me-2"
            >
              <i className="fa-light fa-minus me-1"></i>
              Daha az
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                setMedicine([...medicines, { r1: "", r2: "" }]);
              }}
              href="#"
              className=" block text-sm font-medium mb-2 onedose-color mt-2"
            >
              <i className="fa-light fa-plus me-1"></i>
              Daha fazla
            </a>
          </div>
        </div>
        <div className="md:ml-64 ps-5 mt-5">
          <h1 className="text-start mb-2 text-xl font-semibold">
            Alışkanlıklar
          </h1>
          {addictions.map((element, index) => (
            <div key={index} className="grid grid-cols-2 gap-2">
              <div>
                <label
                  htmlFor={`question_20_1_${index}`}
                  className="text-start block text-sm font-medium mb-2 dark:text-white"
                >
                  Alışkanlığınızın Türü
                </label>
                <input
                  onChange={(e) => {
                    setAddiction(
                      addictions.map((c, i) =>
                        i === index ? { ...c, r1: e.target.value } : c
                      )
                    );
                    setForm((prevState) => ({
                      ...prevState,
                      Alışkanlıklar: {
                        ...prevState["Alışkanlıklar"],
                        ["Alışkanlık " + index]: e.target.value,
                      },
                    }));
                  }}
                  id={`question_20_1_${index}`}
                  type="text"
                  className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Örn: Sigara"
                />
              </div>
              <div>
                <label
                  htmlFor={`question_10_4_${index}`}
                  className="text-start block text-sm font-medium mb-2 dark:text-white"
                >
                  Kullanım Süresi
                </label>
                <input
                  onChange={(e) => {
                    setAddiction(
                      addictions.map((c, i) =>
                        i === index ? { ...c, r2: e.target.value } : c
                      )
                    );
                    setForm((prevState) => ({
                      ...prevState,
                      Alışkanlıklar: {
                        ...prevState["Alışkanlıklar"],
                        ["Kullanım Durumu " + index]: e.target.value,
                      },
                    }));
                  }}
                  id={`question_10_4_${index}`}
                  placeholder="Örn haftada 1 paket"
                  className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                />
              </div>
            </div>
          ))}

          <div className="flex justify-end">
            <a
              onClick={(e) => {
                e.preventDefault();
                const newAddictions = [...addictions];
                newAddictions.pop();
                setAddiction(newAddictions);
              }}
              href="#"
              className=" block text-sm font-medium mb-2 danger mt-2 me-2"
            >
              <i className="fa-light fa-minus me-1"></i>
              Daha az
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                setAddiction([...addictions, { r1: "", r2: "" }]);
              }}
              href="#"
              className=" block text-sm font-medium mb-2 onedose-color mt-2"
            >
              <i className="fa-light fa-plus me-1"></i>
              Daha fazla
            </a>
          </div>
        </div>
        <div className="md:ml-64 ps-5 mt-5">
          <div className="text-start">
            <label
              htmlFor="hs-select-label11"
              className="block text-sm font-medium mb-2 dark:text-white"
            >
              Alerji Durumunuz
            </label>
            <select
              onChange={(e) => {
                setAllergy(e.target.value);
                if (e.target.value !== "true") {
                  setForm((prevState) => ({
                    ...prevState,
                    "Alerji durumunuz": e.target.value,
                  }));
                }
              }}
              id={allergies === "true" ? null : "question_14"}
              className="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
            >
              <option selected>Lütfen Seçiniz</option>
              <option value="true">Alerjim var</option>
              <option value="Alerjim yok">Alerjim yok</option>
            </select>
          </div>
          {allergies === "true" ? (
            <div>
              <label
                htmlFor="input-132"
                className="mt-2 text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Alerjilerinizi yazınız
              </label>
              <textarea
                onChange={(e) => {
                  if (allergies === "true") {
                    setForm((prevState) => ({
                      ...prevState,
                      "Alerji durumunuz": e.target.value,
                    }));
                  }
                }}
                rows="4"
                type="text"
                id={allergies === "true" ? "question_14" : null}
                className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="Lütfen alerjilerinizi ve bunlara ait detayları yazınız"
              />
            </div>
          ) : null}
          <div></div>
        </div>
        <div className="md:ml-64 ps-5 mt-5">
          <div className="text-start">
            <label
              htmlFor="hs-select-label11"
              className="block text-sm font-medium mb-2 dark:text-white"
            >
              Görüş Almak İstediğiniz Hastalığı Ailenizde Yaşayan Var mı?
            </label>
            <select
              onChange={(e) => {
                setRelativeDisease(e.target.value);
                if (e.target.value !== "true") {
                  setForm((prevState) => ({
                    ...prevState,
                    "Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?":
                      e.target.value,
                  }));
                }
              }}
              id={relativeDisease === "true" ? null : "question_15"}
              className="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
            >
              <option selected>Lütfen Seçiniz</option>
              <option value="true">Evet</option>
              <option value="Hayır">Hayır</option>
            </select>
          </div>
          {relativeDisease === "true" ? (
            <div>
              <label
                htmlFor="input-132"
                className="mt-2 text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Lütfen Detay Giriniz (Ailenizde Bu Hastalığı Yaşayan Kişi İle
                Alakalı?)
              </label>
              <textarea
                onChange={(e) => {
                  if (relativeDisease === "true") {
                    setForm((prevState) => ({
                      ...prevState,
                      "Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?":
                        e.target.value,
                    }));
                  }
                }}
                rows="4"
                type="text"
                id={relativeDisease === "true" ? "question_15" : null}
                className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="Yakınlık derecesi (anne, baba, vs), hastalığın süresi ve güncel durum bilgisi"
              />
            </div>
          ) : null}
        </div>
        <div className="md:ml-64 ps-5 mt-5">
          <div className="flex justify-start mt-5">
            <input
              checked={forSomeoneElse}
              onChange={(e) => {
                if (e.target.checked) {
                  setForSomeoneElse(true);
                } else {
                  setForSomeoneElse(false);
                  setRepresentedPatientInformation(null);
                }
              }}
              type="checkbox"
              className="onedose-color shrink-0 mt-0.5 border-gray-200 rounded text-blue-600 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
              id="hs-checkbox-group-11"
            />
            <label
              htmlFor="hs-checkbox-group-11"
              className="text-sm text-gray-500 ml-3 dark:text-gray-400"
            >
              Bu başvuruyu yakınım için yapıyorum
            </label>
          </div>
          <div
            className={
              forSomeoneElse
                ? `justify-start mt-5`
                : `justify-start mt-5 hidden`
            }
          >
            <div className="mt-4">
              <label
                htmlFor="input-label"
                className="text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Yakını olduğunuz kişinin adı
              </label>
              <input
                value={representedPatientInformation?.name || ""}
                onChange={(e) => {
                  setRepresentedPatientInformation((prevState) => ({
                    ...prevState,
                    name: e.target.value,
                  }));
                }}
                type="text"
                id="input-label"
                className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="Yakınınızın adı"
              />
            </div>
            <div className="mt-4">
              <label
                htmlFor="input-label"
                className="text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Yakını olduğunuz kişinin soyadı
              </label>
              <input
                value={representedPatientInformation?.surname || ""}
                onChange={(e) => {
                  setRepresentedPatientInformation((prevState) => ({
                    ...prevState,
                    surname: e.target.value,
                  }));
                }}
                type="text"
                id="input-label"
                className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="Yakınınızın soyadı"
              />
            </div>
            <div className="mt-4">
              <label
                htmlFor="input-label"
                className="text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Yakını olduğunuz kişinin TC Kimlik Numarası
              </label>
              <input
                value={representedPatientInformation?.nationalIdentifier || ""}
                onChange={(e) => {
                  setRepresentedPatientInformation((prevState) => ({
                    ...prevState,
                    nationalIdentifier: e.target.value,
                  }));
                }}
                type="text"
                id="input-label"
                className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="Yakınınızın TC Kimlik Numarası"
              />
            </div>
            <div className="mt-4">
              <label
                htmlFor="input-label"
                className="text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Yakını olduğunuz kişinin doğum tarihi
              </label>
              <div>
                <div className="sm:flex rounded-lg shadow-sm">
                  <span className="py-3 px-4 inline-flex items-center min-w-fit w-full border border-gray-200 bg-gray-50 text-sm text-gray-500 -mt-px -ms-px first:rounded-t-lg last:rounded-b-lg sm:w-auto sm:first:rounded-s-lg sm:mt-0 sm:first:ms-0 sm:first:rounded-se-none sm:last:rounded-es-none sm:last:rounded-e-lg dark:bg-gray-700 dark:border-gray-700 dark:text-gray-400">
                    Doğum tarihi
                  </span>
                  <input
                    value={representedPatientInformation?.birthDateDay || ""}
                    onChange={(e) => {
                      setRepresentedPatientInformation((prevState) => ({
                        ...prevState,
                        birthDateDay: parseInt(e.target.value),
                      }));
                    }}
                    placeholder="Gün"
                    min="1"
                    max="31"
                    type="number"
                    className="py-3 px-4 pe-11 block w-full border-gray-200 sm:shadow-sm -mt-px -ms-px first:rounded-t-lg last:rounded-b-lg sm:first:rounded-s-lg sm:mt-0 sm:first:ms-0 sm:first:rounded-se-none sm:last:rounded-es-none sm:last:rounded-e-lg text-sm relative focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                  />
                  <input
                    value={representedPatientInformation?.birtDateMonth || ""}
                    onChange={(e) => {
                      setRepresentedPatientInformation((prevState) => ({
                        ...prevState,
                        birtDateMonth: parseInt(e.target.value),
                      }));
                    }}
                    placeholder="Ay"
                    min={1}
                    max={12}
                    type="number"
                    className="py-3 px-4 pe-11 block w-full border-gray-200 shadow-sm -mt-px -ms-px first:rounded-t-lg last:rounded-b-lg sm:first:rounded-s-lg sm:mt-0 sm:first:ms-0 sm:first:rounded-se-none sm:last:rounded-es-none sm:last:rounded-e-lg text-sm relative focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                  />
                  <input
                    value={representedPatientInformation?.birthDateYear || ""}
                    onChange={(e) => {
                      setRepresentedPatientInformation((prevState) => ({
                        ...prevState,
                        birthDateYear: parseInt(e.target.value),
                      }));
                    }}
                    placeholder="Yıl"
                    min={1910}
                    max={new Date().getFullYear()}
                    type="number"
                    className="py-3 px-4 pe-11 block w-full border-gray-200 shadow-sm -mt-px -ms-px first:rounded-t-lg last:rounded-b-lg sm:first:rounded-s-lg sm:mt-0 sm:first:ms-0 sm:first:rounded-se-none sm:last:rounded-es-none sm:last:rounded-e-lg text-sm relative focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                  />
                </div>
              </div>
            </div>
            <div className="mt-4">
              <label
                htmlFor="input-label"
                className="text-start block text-sm font-medium mb-2 dark:text-white"
              >
                Yakını olduğunuz kişinin cinsiyeti
              </label>
              <select
                value={representedPatientInformation?.gender || ""}
                onChange={(e) => {
                  setRepresentedPatientInformation((prevState) => ({
                    ...prevState,
                    gender: parseInt(e.target.value),
                  }));
                }}
                className="py-3 px-4 pe-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
              >
                <option>Lütfen seçiniz</option>
                <option value="1">Erkek</option>
                <option value="2">Kadın</option>
                <option value="3">Diğer</option>
              </select>
            </div>
          </div>

          {/* Onay Checkbox ve Ant Design Modalleri */}

          {/* Aydınlatma Metni Checkbox ve Modal */}
          <div className="ps-5 mt-6">
            <div className="flex justify-start text-start items-center">
              <Checkbox
                checked={approve}
                onChange={() => {
                  setApprove(!approve);
                }}
              />
              <Button
                type="link"
                onClick={() => setIsModal128Visible(true)}
                className="text-blue-400 hover:text-green-600 transition-colors focus:outline-none ml-0.5"
              >
                Aydınlatma metnini okuyup onayladım.
              </Button>{" "}
            </div>
            <Modal
              title="Aydınlatma Metni"
              visible={isModal128Visible}
              onCancel={() => setIsModal128Visible(false)}
              width={800}
              footer={[
                <Button
                  key="cancel"
                  onClick={() => setIsModal128Visible(false)}
                >
                  Vazgeç
                </Button>,
                <Button
                  key="ok"
                  type="primary"
                  onClick={() => {
                    setApprove(true);
                    setIsModal128Visible(false);
                  }}
                >
                  Okudum Anladım
                </Button>,
              ]}
            >
              <iframe
                width="100%"
                height="600px"
                src="https://shop.onedose.io/pages/aydinlatma-metni"
                title="Aydınlatma Metni"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ border: "none" }}
              ></iframe>
            </Modal>
          </div>

          {/* Yakını için Aydınlatma Metni Checkbox ve Modal */}
          {forSomeoneElse && (
            <div className="ps-5">
              <div className="flex justify-start text-start items-center">
                <Checkbox
                  checked={approveRelative}
                  onChange={() => {
                    setApproveRelative(!approveRelative);
                  }}
                />
                <Button
                  type="link"
                  onClick={() => setIsModal130Visible(true)}
                  className="text-blue-400 hover:text-green-600 transition-colors focus:outline-none ml-0.5"
                >
                  Yakınım adına başvuru yaptığımı okudum onaylıyorum.
                </Button>
              </div>
              <Modal
                title="Yakını İçin Aydınlatma Metni"
                visible={isModal130Visible}
                width={800} // İsteğe bağlı olarak genişliği ayarlayabilirsiniz
                onCancel={() => setIsModal130Visible(false)}
                footer={[
                  <Button
                    key="cancel"
                    onClick={() => setIsModal130Visible(false)}
                  >
                    Vazgeç
                  </Button>,
                  <Button
                    key="ok"
                    type="primary"
                    onClick={() => {
                      setApproveRelative(true);
                      setApprove2(true);
                      setIsModal130Visible(false);
                    }}
                  >
                    Okudum Anladım
                  </Button>,
                ]}
              >
                <iframe
                  width="100%"
                  height="600px"
                  src="https://www.onedose.io/kisisel-verilerin-aktarilmasina"
                  title="Yakını İçin Aydınlatma Metni"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ border: "none" }}
                ></iframe>
              </Modal>
            </div>
          )}

          {/* Tıbbi İkinci Görüş Beyanı Checkbox ve Modal */}
          {!forSomeoneElse && (
            <div className="ps-5">
              <div className="flex items-center mt-2">
                <Checkbox
                  checked={approve2}
                  onChange={() => {
                    setApprove2(!approve2);
                  }}
                />
                <Button
                  type="link"
                  onClick={() => setIsModal129Visible(true)}
                  className="text-blue-400 hover:text-green-600 transition-colors focus:outline-none ml-0.5 flex items-center text-left pt-5"
                  style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    maxWidth: "100%", // Mobilde daraldıkça genişlik ayarlanır
                  }}
                >
                  <p className="mt-6 md:mt-0">
                    Tıbbi İkinci görüş beyanı bilgilendirme metnini okuyup
                    onayladım.
                  </p>
                </Button>
              </div>

              <Modal
                title="Tıbbi İkinci Görüş Beyanı Bilgilendirme Metni"
                visible={isModal129Visible}
                width={800} // İsteğe bağlı olarak genişliği ayarlayabilirsiniz
                onCancel={() => setIsModal129Visible(false)}
                footer={[
                  <Button
                    key="cancel"
                    onClick={() => setIsModal129Visible(false)}
                  >
                    Vazgeç
                  </Button>,
                  <Button
                    key="ok"
                    type="primary"
                    onClick={() => {
                      setApprove2(true);
                      setIsModal129Visible(false);
                    }}
                  >
                    Okudum Anladım
                  </Button>,
                ]}
              >
                <iframe
                  width="100%"
                  height="600px"
                  src="https://www.onedose.io/tibbi-danismalik-onam-formu"
                  title="Tıbbi İkinci Görüş Beyanı Bilgilendirme Metni"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ border: "none" }}
                ></iframe>
              </Modal>
            </div>
          )}

          <Button
            className="absolute right-2"
            type="link"
            onClick={handleExportToPDF}
          >
            Önizle
          </Button>

          {/* Doğrulama Kodu Modalı */}
          <Modal
            title="Doğrulama Kodu"
            visible={isVerificationCodeModalVisible}
            width={800} // İsteğe bağlı olarak genişliği ayarlayabilirsiniz
            onCancel={() => setIsVerificationCodeModalVisible(false)}
            footer={[
              <Button
                key="cancel"
                onClick={() => setIsVerificationCodeModalVisible(false)}
              >
                Vazgeç
              </Button>,
              isRunning ? (
                <Button
                  key="confirm"
                  type="primary"
                  onClick={() => {
                    dispatch(
                      approveOtp(
                        "Aydınlatma metni & Tıbbi ikinci görüş beyanı bilgilendirme metni",
                        veriCode
                      )
                    );
                  }}
                >
                  Onayla
                </Button>
              ) : (
                <Button
                  key="resend"
                  type="default"
                  onClick={() => {
                    dispatch(getOtp());
                  }}
                >
                  Kodu Tekrar Gönder
                </Button>
              ),
            ]}
          >
            <Input
              value={veriCode}
              onChange={(e) => setVeriCode(e.target.value)}
              placeholder="Doğrulama kodunuzu giriniz"
              type="text"
              className="mb-4"
            />
            <p className="text-sm text-red-400 text-start">
              Kalan süreniz: <b>{formatTime(timeSizeLeft)}</b>
            </p>
          </Modal>
          <Modal
            title="Bilgilendirme"
            visible={isModalVisible}
            footer={null}
            closable={false}
          >
            <p>
              Tıbbi İkinci Görüş platformu, tamamen{" "}
              <strong>
                <u>yazılı görüş</u>
              </strong>{" "}
              alma amacıyla tasarlanmış bir platformdur. Randevu sistemi veya
              hastane hizmetleri ile herhangi bir bağlantısı{" "}
              <strong>
                <u>bulunmamaktadır.</u>
              </strong>{" "}
              Amacımız, uzman görüşlerini hızlı ve pratik bir şekilde
              kullanıcılarımıza ulaştırmaktır.
            </p>
            <div className="flex justify-center items-center mt-6">
              <Button
                type="primary"
                onClick={handleModalClose}
                disabled={isButtonDisabled}
                className="flex justify-center items-center"
              >
                <p>
                  Okudum, Anladım, Onayladım
                  {timeSizeLeft !== 0 ? ` (${timeSizeLeft})` : ""}
                </p>
              </Button>
            </div>
          </Modal>
        </div>

        {pdfBlobUrl ? (
          <PdfViewerModal pdfBlobUrl={pdfBlobUrl} />
        ) : (
          <p>PDF yükleniyor...</p>
        )}

        {/* Onay Butonu ve Diğer Yapılar */}
        <div className="md:ml-64 ps-5 mt-5">
          {props.startApplicationv2.spinner ? (
            <button
              style={{ backgroundColor: `#09C35C` }}
              type="button"
              className="mb-10 w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
            >
              <span
                className="animate-spin inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-white rounded-full"
                role="status"
                aria-label="loading"
              ></span>
              Devam ediyor
            </button>
          ) : institution === 0 ? (
            <button
              onClick={handleVerify}
              style={{ backgroundColor: `#09C35C` }}
              type="button"
              className="mb-10 w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
            >
              Devam et
            </button>
          ) : institution === 1 ? (
            <button
              onClick={handleCreateApplication}
              style={{ backgroundColor: `#09C35C` }}
              type="button"
              className="mb-10 w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
            >
              Devam et
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(NewApplication);
